/**
 * 業界カテゴリ（薬機法対応用）
 *
 * DB の CHECK 制約と一致させること（products.industry_category / amazon_products.industry_category）。
 * NULL（未分類）と 'general'（明示的に薬機法対象外）は区別する。
 */
export const INDUSTRY_CATEGORIES = [
  'cosmetics',
  'quasi_drug',
  'supplement',
  'food_with_function',
  'medical_device',
  'general',
] as const;

export type IndustryCategory = typeof INDUSTRY_CATEGORIES[number];

export const INDUSTRY_CATEGORY_LABELS: Record<IndustryCategory, string> = {
  cosmetics: '化粧品',
  quasi_drug: '医薬部外品',
  supplement: '健康食品・サプリメント',
  food_with_function: '機能性表示食品',
  medical_device: '医療機器',
  general: '一般商品（薬機法対象外）',
};

export const INDUSTRY_CATEGORY_DESCRIPTIONS: Record<IndustryCategory, string> = {
  cosmetics: '化粧水・美容液・スキンケアなど。薬機法の効能効果表示制限の対象。',
  quasi_drug: '薬用化粧品・制汗剤など。承認された効能効果のみ表示可能。',
  supplement: 'サプリメント・健康食品。景表法・健康増進法の対象。',
  food_with_function: '消費者庁に機能性を届出た食品。届出範囲の表現のみ可。',
  medical_device: '家庭用マッサージ器・体温計など。薬機法の対象。',
  general: '上記いずれにも該当しない一般商品。',
};

export function formatIndustryCategory(value: string | null | undefined): string {
  if (!value) return '未分類';
  const key = value as IndustryCategory;
  return INDUSTRY_CATEGORY_LABELS[key] ?? value;
}

export function formatIndustryCategories(values: string[] | null | undefined): string {
  if (!values || values.length === 0) return '未分類';
  return values.map(formatIndustryCategory).join('、');
}
